export enum AudienceStatus {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
  FAILED = 'FAILED',
}

export interface RawAudienceApiResponse {
  advertiser_id: string;
  audience_key: string;
  catalog_key: string;
  control_group_percent?: number | null;
  created_at: string;
  global?: boolean | null;
  id: string;
  name: string;
  synced: boolean | null;
  project_id: string;
  refreshed_at?: string | null;
  rules?: AudienceRules | null;
  size: number | null;
  status: AudienceStatus;
  updated_at: string;
}

export const AudienceOperator = {
  And: 'AND',
} as const;

export type AudienceOperator = (typeof AudienceOperator)[keyof typeof AudienceOperator];

export const actions = ['PURCHASED'] as const;
export const quantityComparers = ['LESS', 'MORE'] as const;
export const objectTypes = ['BRAND', 'CATEGORY'] as const;

export interface AudienceRule {
  action: {
    value: (typeof actions)[number];
    negated: boolean;
  };
  quantity: {
    value: number;
    comparer: (typeof quantityComparers)[number];
  };
  object: {
    type: (typeof objectTypes)[number];
    value: string;
  };
  duration: number;
}

export interface AudienceRules {
  operator: AudienceOperator;
  segments: AudienceRule[];
  auto_refresh: boolean;
}

export interface EstimationRules {
  operator: AudienceOperator;
  segments: AudienceRule[];
}

export interface RawAudienceShoppersResponse {
  url: string;
  updated_at: string;
}

export interface RawCreateAudienceRequestData {
  advertiser_id?: string | null;
  audience_key?: string;
  catalog_key: string;
  global?: boolean | null;
  name: string;
  rules?: AudienceRules | null;
}

export interface RawUpdateAudienceRequestData {
  name?: string | null;
  rules?: AudienceRules | null;
}

export interface RawAudienceEstimationApiResponse {
  size: number | null;
}

export const EMPTY_RULE: AudienceRule = {
  action: {
    negated: false,
    value: 'PURCHASED',
  },
  quantity: {
    value: 0,
    comparer: 'MORE',
  },
  object: {
    type: 'BRAND',
    value: '',
  },
  duration: 84,
};

export const defaultDurations = [
  { label: '2 weeks', value: 14 },
  { label: '4 weeks', value: 28 },
  { label: '6 weeks', value: 42 },
  { label: '12 weeks', value: 84 },
  { label: '6 months', value: 182 },
];
